import ModalWrapper from '@Components/Modals/ModalWrapper/ModalWrapper';
import AssetTypeServices from '@Services/AssetType.services.ts';
import { AssetType } from '@Types/Asset.types';
import { handleRequestError } from '@Utils/request.utils';
import { ErrorDisplay, Toast } from '@kg-internal/pv3-uikit';
import { useState } from 'react';

type Props = {
  show: boolean;
  onClose: () => void;
  onSuccess: () => void;
  assetType?: AssetType;
};

const DeleteAssetTypeModal = ({ show, onClose, onSuccess, assetType }: Props) => {
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

  const handleDeleteAssetType = () => {
    AssetTypeServices.disableAssetType(assetType?.id)
      .then(() => {
        Toast.success("Asset type deleted successfully.");
        onSuccess();
        onClose();
      })
      .catch((error) => handleRequestError(error, setErrorMessage, true));
  };

  return (
    <div className='modal--fit-content modal--w-30vw modal--pt-20vh'>
      <ModalWrapper
        title="Delete Asset Type"
        show={show}
        handleClose={onClose}
        primaryButtonText="Confirm"
        primaryAction={handleDeleteAssetType}>
        {errorMessage ? (
          <ErrorDisplay inline details={errorMessage} />
        ) : (
          <div className='grid'>
            <div className='col-12'>
              <p>
                <b>Code</b> : {assetType?.assetCode}
              </p>
              <p>
                <b>Description</b> : {assetType?.description}
              </p>
            </div>
          </div>
        )}
      </ModalWrapper>
    </div>
  );
};

export default DeleteAssetTypeModal;
